import React, { useState, useEffect, useRef } from 'react';
import { useLang } from '../LanguageContext';
import './Hero.css';

const T = {
  sub:   { ko: 'MEDILOGIS SMART HEALTHCARE PLATFORM', en: 'MEDILOGIS SMART HEALTHCARE PLATFORM' },
  title: { ko: <>IoT 기술로 여는<br/>스마트 헬스케어의 미래</>, en: <>IoT-Powered Future of<br/>Smart Healthcare</> },
  desc:  { ko: <>센서 기반 실시간 모니터링과 데이터 분석으로<br/>더 나은 돌봄의 미래를 만들어갑니다</>,
           en: <>Real-time monitoring and analytics powered by IoT sensors<br/>shaping the future of better care</> },
  stat1: { ko: '도입 기관', en: 'Partner Sites' },
  stat2: { ko: '교체 감지', en: 'Detections' },
};

function AnimatedNumber({ value, suffix, lang }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 2000;
          const steps = 60;
          const increment = value / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= value) {
              setCount(value);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  const formatNumber = (num) => {
    if (lang === 'ko' && num >= 10000) {
      const man = num / 10000;
      return man % 1 === 0 ? man.toFixed(0) + '만' : man.toFixed(1) + '만';
    }
    return num.toLocaleString();
  };

  return (
    <span ref={ref} className="hero-stat-number">
      {formatNumber(count)}<span className="hero-stat-suffix">{suffix}</span>
    </span>
  );
}

function Hero() {
  const [stats, setStats] = useState({ hospital: 0, total: 0, user: 0 });
  const { lang } = useLang();

  useEffect(() => {
    fetch('/api/stats')
      .then(res => res.json())
      .then(data => {
        if (data.hospital) {
          setStats(data);
        }
      })
      .catch(() => {
        // API 실패 시 기본값
        setStats({ hospital: 9, total: 327126, user: 128 });
      });
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <p className="hero-sub">{T.sub[lang]}</p>
        <h1>{T.title[lang]}</h1>
        <p className="hero-desc">{T.desc[lang]}</p>
        {stats.hospital > 0 && (
        <div className="hero-stats">
          <div className="hero-stat-item">
            <AnimatedNumber value={stats.hospital} suffix="+" lang={lang} />
            <p>{T.stat1[lang]}</p>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat-item">
            <AnimatedNumber value={stats.total} suffix="+" lang={lang} />
            <p>{T.stat2[lang]}</p>
          </div>
        </div>
        )}
      </div>
      <div className="hero-scroll">
        <span>SCROLL</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
}

export default Hero;
